import { createTheme, ThemeProvider, Tooltip } from "@mui/material";
import React from "react";

interface IKeydriveTooltip {
    children: any;
    title: string;
    start?: boolean;
}

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#E9EFF4',
          color: '#22638D',
          height: "fit-content",
          textAlign: "left",
          font:" normal normal normal 14px Segoe UI",
          opacity: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)"
        },
        arrow: {
          color: '#E9EFF4',
        },
      },
    },
  },
});

export default function KeydriveTooltip({
    children,
    title,
    start
}: IKeydriveTooltip) {
    return (
        <ThemeProvider theme={theme}>
            <Tooltip title={title} disableInteractive placement="bottom" arrow PopperProps={{
                popperOptions: {
                  modifiers: [0, 80],
                  placement: start ? "bottom-start" : "auto"
                }
            }}>
                {children}
            </Tooltip>
        </ThemeProvider>
    )
}